
const styles = {
  container: {
    backgroundColor: 'bg-gray-50',
    border: 'border border-gray-200',
    shadow: 'shadow-lg',
    animation: 'pro-message 0.5s forwards'
  },
  header: {
    background: 'bg-gradient-to-r from-blue-600 to-blue-700',
    textColor: 'text-white',
    border: 'border-b border-blue-500',
    animation: 'slide-in 0.5s forwards'
  },
  avatar: {
    background: 'bg-blue-600',
    text: 'text-white',
    border: 'border-2 border-blue-400',
    animation: 'pro-avatar-pulse 2s infinite',
    shape: 'rounded-full aspect-square overflow-hidden'
  },
  messages: {
    bot: {
      background: 'bg-white',
      text: 'text-gray-800',
      shadow: 'shadow-sm',
      border: 'border border-gray-100',
      animation: 'pro-message 0.5s forwards',
      transition: 'all 0.3s ease'
    },
    user: {
      background: 'bg-blue-600',
      text: 'text-white',
      shadow: 'shadow-sm',
      animation: 'pro-message 0.5s forwards',
      transition: 'all 0.3s ease'
    }
  },
  typingIndicator: {
    background: 'bg-white',
    dot: 'bg-blue-600',
    border: 'border border-gray-100',
    animation: 'pro-typing 0.5s forwards',
    dotAnimation: 'typing-bounce 1.4s infinite'
  },
  input: {
    background: 'bg-white',
    text: 'text-gray-800',
    placeholder: 'text-gray-400',
    border: 'border border-gray-200 focus:border-blue-500',
    transition: 'all 0.3s ease',
    button: {
      background: 'bg-blue-600 hover:bg-blue-700',
      text: 'text-white',
      animation: 'pro-button-hover 0.3s ease',
      hover: {
        transform: 'translateY(-2px)',
        shadow: 'shadow-lg'
      }
    }
  },
  animations: {
    '@keyframes pro-message': {
      '0%': {
        opacity: 0,
        transform: 'translateY(10px)'
      },
      '100%': {
        opacity: 1,
        transform: 'translateY(0)'
      }
    },
    '@keyframes pro-typing': {
      '0%': {
        opacity: 0,
        transform: 'translateY(10px)'
      },
      '100%': {
        opacity: 1,
        transform: 'translateY(0)'
      }
    },
    '@keyframes typing-bounce': {
      '0%, 80%, 100%': {
        transform: 'translateY(0)'
      },
      '40%': {
        transform: 'translateY(-8px)'
      }
    },
    '@keyframes pro-avatar-pulse': {
      '0%, 100%': {
        transform: 'scale(1)',
        boxShadow: '0 0 0 0 rgba(37, 99, 235, 0.4)'
      },
      '50%': {
        transform: 'scale(1.05)',
        boxShadow: '0 0 0 10px rgba(37, 99, 235, 0)'
      }
    },
    '@keyframes pro-button-hover': {
      '0%': {
        transform: 'translateY(0)'
      },
      '100%': {
        transform: 'translateY(-2px)'
      }
    }
  }
};

export default styles;